// removed by extract-text-webpack-plugin
module.exports = {"menu":"src-pages----index-module---menu---2wZFh","indexContent":"src-pages----index-module---indexContent---1Ll7Q","hero":"src-pages----index-module---hero---2Osae"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/index.module.css
// module id = 359
// module chunks = 35783957827783